import React, { Component } from "react";
import { connect } from "react-redux";
import { SplashComponent } from "./SplashComponent";
import { urlPath } from "../../Settings";
import { getAuthHeader } from "../../../utils/security";
import { toggleSplash } from "../../../redux/actions/index";
const mapStateToProps = state => {
  return {
    language: state.language,
    booking: state.booking,
    splashVisible: state.splashVisible,
    currentLangCode: state.currentLangCode
  };
};
const mapDispatchToProps = dispatch => {
  return {
    toggleSplash: val => dispatch(toggleSplash(val))
  };
};

class SplashContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      splashFrameUrl: null
    };
  }
  componentDidMount() {
    const { booking, currentLangCode } = this.props;
    fetch(
      urlPath +
        "/api/customframe?key=splashMobile&matspec=" +
        booking.currentMaterialSpecification +
        "&language=" +
        currentLangCode +
        "&timezone=" +
        Intl.DateTimeFormat().resolvedOptions().timeZone,
      { credentials: "include", headers: getAuthHeader() }
    )
      .then(response => response.json())
      .then(data => {
        this.setState({ splashFrameUrl: data.url });
        console.log(localStorage.getItem("showSplashMobile"));
        if (
          !localStorage.getItem("showSplashMobile") ||
          localStorage.getItem("showSplashMobile") == "true"
        )
          toggleSplash(true);
      })
      .catch(e => console.error("Cannot load splash frame", e));
  }
  componentWillUnmount() {
    console.log("unmounting splash modal");
  }
  handleOk = e => {
    const { toggleSplash } = this.props;
    toggleSplash(false);
  };
  onCheckboxChange = e => {
    console.log(e.target.checked);
    localStorage.setItem("showSplashMobile", !e.target.checked);
  };
  render() {
    const { language, splashVisible } = this.props;
    return (
      <SplashComponent
        language={language}
        splashFrameUrl={this.state.splashFrameUrl}
        visible={splashVisible}
        handleOk={this.handleOk}
        onCheckboxChange={this.onCheckboxChange}
      />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SplashContainer);



// WEBPACK FOOTER //
// ./src/components/Mobile/Splash/SplashContainer.js